/**
 * AnalyticsTracker — initializes Google Analytics 4 once and emits a page_view
 * on every SPA route change so each tab/page is captured. Renders nothing.
 *
 * Must be mounted INSIDE <BrowserRouter> (it uses useLocation).
 */
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { initGA, trackPageView } from '@/lib/analytics';

export default function AnalyticsTracker() {
  const location = useLocation();

  useEffect(() => { initGA(); }, []);

  useEffect(() => {
    trackPageView(location.pathname + location.search);
  }, [location.pathname, location.search]);

  return null;
}
